export default [
  {
    path: '/activity-signup',
    component: () => import('@/views/activitySignUp/Index.vue'),
    name: 'activity-signup',
    meta: {
      title: '报名信息',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/activity-pay',
    component: () => import('@/views/activitySignUp/Pay.vue'),
    name: 'activity-pay',
    meta: {
      title: '报名信息',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/activity-success',
    component: () => import('@/views/activitySignUp/Success.vue'),
    name: 'activity-success',
    meta: {
      title: '报名信息',
      backgroundClass: 'bg-gray',
    },
  },
];
